import script from "./AppMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppMain.vue?vue&type=script&lang=ts&setup=true"

import "./AppMain.vue?vue&type=style&index=0&id=f09ffdf8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.4.27_vue@3.2.36_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f09ffdf8"]])

export default __exports__